import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import { useSetting } from '../../util/useSetting';
import ShortTask from './components/ShortTasks';
import PracticeTask from './components/PracticeTasks';
import { DATA_1 } from './components/PracticeTask_1_data';
import { DATA_2 } from './components/PracticeTask_2_data';
import { DATA_3 } from './components/PracticeTask_3_data';
import { DATA_4 } from './components/PracticeTask_4_data';
import { DATA_5 } from './components/PracticeTask_5_data';
import { DATA_6 } from './components/PracticeTask_6_data';
import { SHORT_TASK_QUESTIONS_1 } from './components/ShortTask_1_data';
import { SHORT_TASK_QUESTIONS_2 } from './components/ShortTask_2_data';
import { SHORT_TASK_QUESTIONS_3 } from './components/ShortTask_3_data';
import PracticeTaskAICommentsStyles from './components/PracticeTaskAICommentsStyles.css';

const RESEARCHES = [
    {
        id: '1',
        name: '香港學生睡眠',
        image: '/secondary/tasks/r1.png',
        subtitle: '研究測試 A-1'
    },
    {
        id: '2',
        name: '機器人',
        image: '/secondary/tasks/r2.png',
        subtitle: '研究測試 2'
    },
      { 
    id: '3',
    name: '小販文化',
    image: '/secondary/tasks/p1.png',
    subtitle: '研究測試 B-1'
  },
  {
    id: '4',
    name: '香港學生運動',
    image: '/secondary/tasks/p2.png',
    subtitle: '研究測試 B-2'
  },
  { 
    id: '5',
    name: '孤獨感',
    image: '/secondary/tasks/p3.png',
    subtitle: '研究測試 C-1'
  },
  {
    id: '6',
    name: '香港氣候變化',
    image: '/secondary/tasks/p4.png',
    subtitle: '研究測試 C-2'
  },

]


const DICT={
    '1':{
        shortTaskQuestions: SHORT_TASK_QUESTIONS_1,
        practiceTaskData: DATA_1,
    },
    '2':{
        shortTaskQuestions: SHORT_TASK_QUESTIONS_1,
        practiceTaskData: DATA_2,
    },
    '3':{
        shortTaskQuestions: SHORT_TASK_QUESTIONS_2,
        practiceTaskData: DATA_3,
    },
    '4':{
        shortTaskQuestions: SHORT_TASK_QUESTIONS_2,
        practiceTaskData: DATA_4,
    },
    '5':{
        shortTaskQuestions: SHORT_TASK_QUESTIONS_3,
        practiceTaskData: DATA_5,
    },
    '6':{
        shortTaskQuestions: SHORT_TASK_QUESTIONS_3,
        practiceTaskData: DATA_6,
    },
}

function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const [data, setdata] = useState(RESEARCHES.filter(item => item.id === id)?.[0])
    const [isLoading, setisLoading] = useState(false)
    const { fontSize } = useSetting();




    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)
        const filter = {}
        // if (status !== '全部') filter.status = status
        // let result = await fetchSchoolMissions(props.token.token, filter, { limit, skip: (page - 1) * limit });
        // if (result.result) {
        //     setdata(result.result)
        //     settotal(result.count || 0)
        // } else {
        //     alert('Fetch data error')
        // }
        setisLoading(false)
    }



    useEffect(() => {
        const timer = setTimeout(fetchData, 500)
        // const interval = setInterval(fetchData,1000*30)
        return () => {
            clearTimeout(timer)
            // clearInterval(interval)
        }
    }, [searchParams])


    const [isDoingShortTask, setisDoingShortTask] = useState(true)
    const [isDoingReadingTask, setisDoingReadingTask] = useState(false)

    return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex gap-[16px]' style={{ fontSize }}>

            {isDoingShortTask && <ShortTask 
                data={DICT[id]?.shortTaskQuestions}   
                onSubmit={() => {
                    setisDoingShortTask(false);
                    setisDoingReadingTask(true);
            }} />}
            {isDoingReadingTask && <PracticeTask 
            data={DICT[id]?.practiceTaskData}
            onSubmit={() => {
                    setisDoingReadingTask(false);
            }} onExit={() => navigate('/platform2/research-practices')} />}

            {isLoading && <LoadingPage />}
        </div>
    );
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
